import { en } from './en';
import { fr } from './fr';

export type { Translation } from './type';
export const resources = {
  en: { translation: en },
  fr: { translation: fr },
};
